var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-column"},[(_vm.isVisible)?_c('BaseLink',{attrs:{"icon-right":"angle-right","to":{ name: 'match', params: { id: _vm.match.id } }}},[_vm._v(" "+_vm._s(_vm.$t('global.more'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }